import { render } from "./Step3.vue?vue&type=template&id=b66579e4"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__